<template>

    <div class="content-overlay n-row">

        <div class="in-content" :class="{ clsng : Global.tempClosingOverlay }">

            <div class="head">
                <h5>
                    <span class="txt-grt">{{ Global.rowIdToEdit ? "Edit row" : "Add new row"}}</span>
                    <template v-if="!Global.rowIdToEdit || !(currentStep == 2 && totalStep == 2)">
                        <span class="steps" v-if="Global.rowIdToEdit">{{ currentStep-1 }}/{{ totalStep-1 }}</span>
                        <span class="steps" v-else>{{ currentStep }}/{{ totalStep }}</span>    
                    </template>
                </h5>
                <span class="x" @click.prevent="closeRowOverlay">
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
                    <path d="M19.4706 2.5L2.5 19.4706" stroke="white" stroke-width="3" stroke-linecap="square"/>
                    <path d="M19.4706 19.4706L2.5 2.5" stroke="white" stroke-width="3" stroke-linecap="square"/>
                    </svg>
                </span>
            </div>

            <div class="inner-content">
                
                <transition
                    name="fade"
                    mode="out-in"
                >
                    <keep-alive max="3">
                        <NewRowOne @rowType="rowTypeCheck" v-if="currentStep == 1" @nxt="goTo(2)"></NewRowOne>

                        <NewRowTwoAuto v-if="currentStep == 2 && rowType == 'auto'" @prv="goTo(1)"></NewRowTwoAuto>
                        <NewRowTwoTag v-if="currentStep == 2 && rowType == 'tag'" @prv="goTo(1)"></NewRowTwoTag>
                        <NewRowTwoManual v-if="currentStep == 2 && rowType == 'manual'" @prv="goTo(1)" @nxt="goTo(3)"></NewRowTwoManual>

                        <NewRowThreeManual
                            v-if="currentStep == 3 && rowType == 'manual'"
                            @prv="goTo(2)"
                        >
                        </NewRowThreeManual>
                    </keep-alive>
                </transition>
                
            </div>
            
        </div>
        
    </div>

</template>

<script>

    import Global from '../lib/GlobalState'
    import NewRowOne from '../components/homepage/NewRowOne'
    import NewRowTwoAuto from '../components/homepage/NewRowTwoAuto'
    import NewRowTwoTag from '../components/homepage/NewRowTwoTag'
    import NewRowTwoManual from '../components/homepage/NewRowTwoManual'
    import NewRowThreeManual from '../components/homepage/NewRowThreeManual'

    export default {

        name: 'RowOverlay',

        components: {
            NewRowOne,
            NewRowTwoAuto,
            NewRowTwoTag,
            NewRowTwoManual,
            NewRowThreeManual
        },

        data() {
            return {
                Global,
                currentStep: 1,
                rowType: 'auto',
            }
        },

        computed: {
            totalStep() {
                if (this.rowType == 'manual')
                    return 3
                else
                    return 2
            },
        },

        mounted() {
            if(Global.rowIdToEdit) {
                this.initEditMode()
            }
        },

        methods: {

            initEditMode() {
                this.currentStep = 2
                
                const row = this.Global.rows.find((row) => {
                    return this.Global.rowIdToEdit == row.id
                })

                this.rowType = row.type
                this.Global.newRowOverlay = Object.assign({}, row)
            },

            rowTypeCheck(val) {
                this.rowType = val
            },

            goTo(num) {
                this.currentStep = num
            },

            closeRowOverlay() {
                return new Promise((resolve) => {
                    this.Global.tempClosingOverlay = true
                    setTimeout(() => { this.Global.activeBlurredOverlay = false }, 300)
                    setTimeout(() => { 
                        this.Global.activeRowOverlay = false 
                        resolve()
                    }, 600)
                })
            }
        }
    }
</script>